import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const Principal = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Principal's Message"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Principal's Message" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
          <div class="container">
            <div class="row align-items-start">
              <div className='col-md-12'>
                  <h2 class="title mb-3 text-center"><span class="text-primary">Principal's Message</span></h2>
                  <div className="curved-line mx-auto mt-3"></div>
              </div>
              <div class="col-md-8">
                <div class="mb-4 pr-lg-5">             
                    <p>P.M.S. is an amalgamation of competent teacher's infrastructure, experienced and efficient administration. With the vision to create a safe and supportive environment for our students we provide a perfect balance of academics, sports, artistic and social opportunities.</p>
                    <p> My prime concern as a principal is to see the children with happy and enthusiastic faces. I believe in giving the students strong values along with a set of wings, so that they may be equipped to face the challenges of the rapidly changing world.</p>
                    <p> P.M.S. gives lots of importance to discipline - a care value, encouraging students to develop a sense of responsibility through a well-planned academic schedule, House system, Various competition and sports activities.</p>
                    <p>In PM.S. there is strong environment of parental involvement, for they recognize the need of our support between the school and the students. In PM.S. teachers reach homes of students for better connectivity and to bridge the gap between school and home by the way of home visits.</p>
                    <p>P.M.S. always strived hard to impart value-based education to cope up with the present demand. I believe in discipline which results in perfection and makes the individual confident, so that my students will also be well in studies and keep up high values, which they have is them.</p>
                    <p>Our mission is to strive constantly to earn greater height the school environment provides a multitude of activities and opportunities for self-fulfilment that will challenge and reward the children.</p>
                    <p className='pb-0 mb-0 pt-2 fw-bold'>Mrs. Sharmila Singh</p>
                    <p>Principal</p>
                </div>            
              </div> 
              <div class="col-md-4">
                  <img src="images/team/principal-new.png" className='w-100' alt='' style={{objectFit:'cover'}} />
              </div>         
            </div>
          </div>
      </section>
    </>
  )
}

export default Principal
